import { css, StyleObjectOrFn, useTheme } from '@chakra-ui/react';

export const useGetCss = () => {
  const theme = useTheme();

  return (styles: StyleObjectOrFn) => {
    return css(styles)(theme as any);
  };
};
